<template>
  <div class="deep-link">
    <img class="app-icon" src="../assets/images/app-logo.svg" alt="" />
    <h1>Add this pass to the Utah State Park App</h1>
    <v-divider class="dividing"></v-divider>
    <h2>Pass Information</h2>
    <p>Order Number: {{ order_number }}</p>
    <p>License Plate: {{ license_plate }}</p>
    <v-divider class="dividing"></v-divider>
    <button class="green-button" @click="reload()">Add Pass to App</button>
    <div class="store-links">
      <p>Or download the app:</p>
      <a :href="appStoreLink" target="_blank">iOS App Store</a>
      <span class="seperator">|</span>
      <a :href="playStoreLink" target="_blank">Google Play Store</a>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "DeepLink",
  data() {
    return {
      id: "",
      order_number: "",
      license_plate: "",
      appStoreLink:
        "https://apps.apple.com/us/app/utah-state-parks/id1638662132",
      playStoreLink:
        "http://play.google.com/store/apps/details?id=edu.utahtech.parkspass.utahstateparks",
    };
  },
  created() {
    console.log("DeepLink component created");
    this.id = this.$route.params.orderid || "";
    this.fetchData();
  },
  methods: {
    reload() {
      this.linkToApp();
    },
    fetchData() {
      console.log("Fetching data...");
      console.log("Auth Code:", this.id);
      var settings = {
        url: `https://trailwaze.info/parkspass/api/getPassData_search.php?auth_code=${this.id}`,
        method: "GET",
        timeout: 0,
        headers: {
          PARKSPLUS_AUTH: "d1f713f7-0050-4c7c-ad9f-463630dc46a0",
        },
      };
      var _this = this;
      $.ajax(settings).done(function (response) {
        console.log(response);
        _this.order_number = response.data[0].order_number;
        _this.license_plate = response.data[0].license_plate;
        _this.linkToApp();
      });
    },
    linkToApp() {
      console.log(
        "Linking to app with:",
        this.order_number,
        this.license_plate
      );

      const deepLink = `parkspassutah://order/track?orderNumber=${this.order_number}&licensePlate=${this.license_plate}`;

      // Detect platform
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
      const isAndroid = /android/i.test(userAgent);
      const isMobile = isIOS || isAndroid;

      // Only try deep link on mobile devices
      if (isMobile) {
        let hasFocusChanged = false;

        // Listen for visibility change (app opening takes user away from browser)
        const visibilityHandler = () => {
          if (document.hidden) {
            hasFocusChanged = true;
          }
        };

        // Listen for blur (app opening takes focus away)
        const blurHandler = () => {
          hasFocusChanged = true;
        };

        document.addEventListener("visibilitychange", visibilityHandler);
        window.addEventListener("blur", blurHandler);

        // Try to open the app
        window.location.href = deepLink;

        // Check after delay if app didn't open
        setTimeout(() => {
          // Clean up listeners
          document.removeEventListener("visibilitychange", visibilityHandler);
          window.removeEventListener("blur", blurHandler);

          // If focus didn't change and enough time has passed, app likely not installed
          if (!hasFocusChanged && !document.hidden) {
            if (isIOS) {
              window.location.href = this.appStoreLink;
            } else if (isAndroid) {
              window.location.href = this.playStoreLink;
            }
          }
        }, 2500);
      } else {
        // Desktop - just show the page with download links
        console.log("Desktop detected - showing download links instead");
      }
    },
  },
};
</script>

<style scoped>
.seperator {
  margin: 0 10px;
  stroke: #000;
}
.green-button {
  border-radius: 50px;
  border: 1px solid #727a35;
  background: #727a35;
  color: #fff;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 9px 24px;
  margin-top: 10px;
}
.dividing {
  margin: 25px 0px;
  border-color: #000 !important;
  width: 80%;
  max-width: 700px;
}
h1 {
  color: #484d54;
  text-align: center;
  font-family: Roboto;
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
h2 {
  color: #484d54;
  text-align: center;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  padding-bottom: 5px;
}
p {
  color: #484d54;
  text-align: center;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 5px 0px;
}
.app-icon {
  width: 72px;
  height: 72px;
  margin-bottom: 30px;
  margin-top: 130px;
}
.deep-link {
  padding: 20px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.store-links {
  margin-top: 100px;
  padding: 20px;
  background-color: #f5f5f5;
  border-radius: 8px;
}
.store-links > p {
  color: #000;
  text-align: center;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.store-links a {
  color: #007dff;

  text-align: center;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration: none;
}

.store-links a:hover {
  text-decoration: underline;
}

.info {
  font-size: 18px;
  margin: 20px 0;
}

.info-small {
  font-size: 14px;
  color: #666;
}
@media only screen and (max-width: 425px) {
  .app-icon {
    margin-top: 30px;
  }
  h1 {
    color: #484d54;
    text-align: center;
    font-family: Roboto;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  h2 {
    color: #484d54;
    text-align: center;
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  p {
    color: #484d54;
    text-align: center;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .store-links > a {
    color: #007dff;
    text-align: center;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .store-links {
    margin-top: 50px;
  }
}
</style>
